import { makeStyles } from '@mui/styles';


export const useStyle = makeStyles((theme) => ({
  marginLeft: {
    marginLeft: theme.spacing(3),
  },
  
  marginTop: {
    marginTop: theme.spacing(2)
  },
  
  formLabel: {
    paddingTop: 20,
    paddingBottom: -10,
  },
  
  formLabelSpacing: {
    marginTop: 15,
  },

  labelWrapper: {
    paddingTop: 0,
    paddingLeft: 10,
  },

  skeleton: {
    width: '250px'
  }
}));
